import { useModal } from '@billy/design-system'
import { createContext, ReactNode, useCallback, useContext, useState } from 'react'

import { ModalId } from '../../../enums/modalId'

interface CreateFolderModalContextValue {
  parentFolderId: string | null
  openCreateFolderModal: (parentFolderId: string | null) => void
}

const CreateFolderModalContext = createContext<CreateFolderModalContextValue | undefined>(undefined)

interface CreateFolderModalProviderProps {
  children: ReactNode
}

export const CreateFolderModalProvider = ({ children }: CreateFolderModalProviderProps) => {
  const [parentFolderId, setParentFolderId] = useState<string | null>(null)
  const { open } = useModal(ModalId.DocumentsCreateFolderActionModal)

  const openCreateFolderModal = useCallback(
    (folderId: string | null) => {
      setParentFolderId(folderId)
      open()
    },
    [open],
  )

  return (
    <CreateFolderModalContext.Provider value={{ parentFolderId, openCreateFolderModal }}>
      {children}
    </CreateFolderModalContext.Provider>
  )
}

export const useCreateFolderModal = (): CreateFolderModalContextValue => {
  const context = useContext(CreateFolderModalContext)

  if (!context) {
    throw new Error('useCreateFolderModal must be used within a CreateFolderModalProvider')
  }

  return context
}
